import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const getRGB = (hex: string) => {
  hex = hex.replace('#', '')

  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  return `${r}, ${g}, ${b}`
}

const useStyles = makeStyles((theme: Theme) => ({
  formBox: {
    width: '100%',
    height: '200px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.3rem',
    margin: '1rem',
    borderRadius: '0.33rem',
    border: `2px dashed ${theme.palette.primary.main}`,
    backgroundColor: `rgba(${getRGB(theme.palette.primary.main)},0.04)`,
    color: theme.palette.primary.main,
    transition: 'all 300ms',
    userSelect: 'none',
    position: 'relative',
    padding: '2.5rem',

    '&:hover': {
      backgroundColor: `rgba(${getRGB(theme.palette.primary.main)},0.2)`,
    },

    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    },

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  },

  formBoxBase: {
    width: '100%',
    height: '200px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.3rem',
    margin: '1rem',
    borderRadius: '0.33rem',
    border: `2px dashed ${theme.palette.primary.main}`,
    backgroundColor: `#FFFFFF`,
    color: theme.palette.primary.main,
    transition: 'all 300ms',
    userSelect: 'none',
    position: 'relative',
    padding: '2.5rem',

    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    },

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  },

  formBoxWhite: {
    width: '100%',
    height: '200px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.3rem',
    margin: '1rem',
    borderRadius: '0.33rem',
    border: `2px dashed ${theme.palette.primary.main}`,
    backgroundColor: `#000000`,
    color: theme.palette.primary.main,
    transition: 'all 300ms',
    userSelect: 'none',
    position: 'relative',
    padding: '2.5rem',

    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
    },

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  },

  boxText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 !important',
    margin: '0 !important',
    gap: '0.4rem',
    fontSize: '0.9rem !important',
    lineHeight: '2rem !important',
    width: '100%',
    minWidth: '200px',
    maxWidth: '310px',
    textAlign: 'center',

    [theme.breakpoints.down('lg')]: {
      flexDirection: 'column !important',
    },
  },

  formButton: {
    height: '35px !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0rem 0.15rem !important',
    padding: '0.5rem 0rem !important',
    fontSize: '1rem !important',
  },

  deleteButton: {
    position: 'absolute',
    top: '0.5rem',
    right: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0.5rem !important',
    margin: '0 !important',
    borderRadius: '0.5rem',
    backgroundColor: '#FEEBEE',
    cursor: 'pointer',
    transition: 'all 300ms',

    '& .MuiSvgIcon-root': {
      fontSize: '1.5rem',
      color: '#BA1A1A !important',
    },

    '&:hover': {
      backgroundColor: '#F8D7DA',
    },
  },

  itemBox: {
    '& span': {
      margin: '0.25rem !important',
    },
  },

  colorBox: {
    width: '100%',
    height: '200px',
    marginTop: '1rem',
    marginBottom: '0.25rem',
    borderRadius: '0.75rem',
  },

  logoBox: {
    width: '100%',
    height: '250px',
    objectFit: 'cover',
  },

  formBoxColor: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
    margin: '2rem 0',
  },
}))

export { useStyles }
